import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval, Observable } from 'rxjs';
import { GlobalErrorHandlerService } from '../error-handler/global-error-handler.service';
import { VersionUpdateService } from './version-update.service';

@Injectable({
  providedIn: 'root',
})
export class CheckForUpdateService {
  constructor(update: SwUpdate, versionUpdateService: VersionUpdateService) {
    const everyTenMinutes$: Observable<number> = interval(60 * 1000 * 10);
    everyTenMinutes$.subscribe(() => void update.checkForUpdate());

    update.versionUpdates.subscribe(($event) => {
      if ($event.type === 'VERSION_READY') {
        update
          .activateUpdate()
          .then(CheckForUpdateService.unregisterServiceWorkerAndRefresh)
          .then(() => versionUpdateService.handleVersionMismatch());
      }
    });

    update.unrecoverable.subscribe(($event) => {
      if ($event.type === 'UNRECOVERABLE_STATE') {
        GlobalErrorHandlerService.handleChunkError({
          err: new TypeError('importing a module script failed'),
          from: 'global',
        });
      }
    });
  }

  private static async unregisterServiceWorkerAndRefresh(): Promise<void> {
    const registrations: ReadonlyArray<ServiceWorkerRegistration> = await navigator.serviceWorker.getRegistrations();

    if (!registrations.length) {
      return Promise.resolve(undefined);
    }

    for (const registration of registrations) {
      await registration.unregister();
    }

    return Promise.resolve(undefined);
  }
}
